<div class="modal-body">
  <div class="row">
    <div class="col-12 d-flex flex-column justify-content-center align-items-center p-3">
      <i class="fa fa-spinner fa-spin fa-5x"></i>
      <h5 *ngIf="loadingText" class="mt-3 mb-0">{{ loadingText | translate }}</h5>
    </div>
  </div>
</div>
